document.addEventListener('turbolinks:load', function() {
  const fileInput = document.getElementById('upload_csv');
  const checkBtn = document.getElementById('check-csv-btn');
  const uploadBtn = document.getElementById('upload-csv-btn');
  const validationMessage = document.getElementById('upload_validation_message');
  const fileText = document.querySelector('[data-js-elem="fileuploadText"]');
  const checkBtnContainer = document.querySelector('.csv-check-btn');
  const uploadBtnContainer = document.querySelector('.csv-upload-btn');

  if (!fileInput || !checkBtn || !uploadBtn || !validationMessage) {
    return; // 必要な要素がない場合は処理を中止
  }

  let csvValidated = false;
  
  // \u521d\u671f\u72b6\u614b\u3067\u30c1\u30a7\u30c3\u30af\u30dc\u30bf\u30f3\u3092\u7121\u52b9\u5316
  if (!fileInput.files[0]) {
    checkBtn.disabled = true;
    if (checkBtnContainer) {
      checkBtnContainer.classList.add('disabled');
    }
  }

  // ファイル選択時の処理
  fileInput.addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (file) {
      fileText.textContent = file.name;
      // ファイルが変更されたらバリデーション状態をリセット
      csvValidated = false;
      uploadBtn.disabled = true;
      validationMessage.value = '';
      
      // ファイル選択後、チェックボタンをbtn-updateに変更して有効化
      checkBtn.disabled = false;
      if (checkBtnContainer) {
        checkBtnContainer.classList.remove('btn-csvdl');
        checkBtnContainer.classList.add('btn-update');
        checkBtnContainer.classList.remove('disabled');
      }
      // アップロードボタンをbtn-csvdlに戻して無効化（ファイル再選択時のリセット）
      uploadBtn.disabled = true;
      if (uploadBtnContainer) {
        uploadBtnContainer.classList.add('btn-csvdl');
        uploadBtnContainer.classList.remove('btn-update');
        uploadBtnContainer.classList.add('disabled');
      }
    } else {
      fileText.textContent = '選択されていません';
      csvValidated = false;
      uploadBtn.disabled = true;
      validationMessage.value = '';
      
      // ファイル未選択時は両方のボタンをbtn-csvdlに戻して無効化（初期状態）
      checkBtn.disabled = true;
      if (checkBtnContainer) {
        checkBtnContainer.classList.add('btn-csvdl');
        checkBtnContainer.classList.remove('btn-update');
        checkBtnContainer.classList.add('disabled');
      }
      // アップロードボタンも初期状態に戻す
      uploadBtn.disabled = true;
      if (uploadBtnContainer) {
        uploadBtnContainer.classList.add('btn-csvdl');
        uploadBtnContainer.classList.remove('btn-update');
        uploadBtnContainer.classList.add('disabled');
      }
    }
  });

  // チェックボタンクリック時の処理
  checkBtn.addEventListener('click', function() {
    const file = fileInput.files[0];
    
    if (!file) {
      validationMessage.value = 'CSVファイルを選択してください。';
      return;
    }

    if (!file.name.endsWith('.csv')) {
      validationMessage.value = 'CSVファイルを選択してください。';
      return;
    }

    // ファイルサイズチェック（10MB以下）
    if (file.size > 10 * 1024 * 1024) {
      validationMessage.value = 'ファイルサイズは10MB以下にしてください。';
      return;
    }

    const reader = new FileReader();
    reader.onload = function(e) {
      const csvContent = e.target.result;
      
      // CSVバリデーション実行
      validateCSV(csvContent);
    };
    reader.readAsText(file, 'UTF-8');
  });

  // CSV検証関数
  function validateCSV(csvContent) {
    // Ajaxでサーバー側の検証を実行
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || 
                     document.querySelector('[name="authenticity_token"]')?.value;
    
    if (!csrfToken) {
      validationMessage.value = 'CSRFトークンが見つかりません。ページを再読み込みしてください。';
      return;
    }
    
    fetch('/matching/services/check_csv', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ csv_content: csvContent })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.valid) {
        validationMessage.value = 'チェック完了：エラーはありませんでした。\nCSVアップロードボタンを押してアップロードしてください。';
        csvValidated = true;
        
        // チェック成功後、チェックボタンをbtn-csvdlに変更して無効化
        checkBtn.disabled = true;
        if (checkBtnContainer) {
          checkBtnContainer.classList.add('btn-csvdl');
          checkBtnContainer.classList.remove('btn-update');
          checkBtnContainer.classList.add('disabled');
        }
        // アップロードボタンをbtn-updateに変更して有効化
        uploadBtn.disabled = false;
        if (uploadBtnContainer) {
          uploadBtnContainer.classList.remove('btn-csvdl');
          uploadBtnContainer.classList.add('btn-update');
          uploadBtnContainer.classList.remove('disabled');
        }
      } else {
        validationMessage.value = 'エラーが見つかりました：\n\n' + data.errors.join('\n');
        csvValidated = false;
        uploadBtn.disabled = true;
        
        // チェック失敗時はボタンの状態を維持
      }
    })
    .catch(error => {
      console.error('Error:', error);
      validationMessage.value = 'チェック中にエラーが発生しました。';
      csvValidated = false;
      uploadBtn.disabled = true;
      
      // エラー時はボタンの状態を維持
    });
  }

  // フォーム送信前の確認
  const form = document.getElementById('csv-upload-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (!csvValidated) {
        e.preventDefault();
        alert('CSVファイルのチェックを実行してください。');
        return false;
      }
      
      // アップロード中はボタンを無効化
      uploadBtn.disabled = true;
      uploadBtn.value = 'アップロード中...';
    });
  }

  // ×ボタン（ファイル削除）クリック時の処理
  $(document).on('click', '[data-js-trigger="fileuploadDel"]', function() {
    // ファイルが削除されたので、両方のボタンを初期状態に戻す
    csvValidated = false;
    
    // チェックボタンを初期状態に戻す
    checkBtn.disabled = true;
    if (checkBtnContainer) {
      checkBtnContainer.classList.add('btn-csvdl');
      checkBtnContainer.classList.remove('btn-update');
      checkBtnContainer.classList.add('disabled');
    }
    
    // アップロードボタンも初期状態に戻す
    uploadBtn.disabled = true;
    if (uploadBtnContainer) {
      uploadBtnContainer.classList.add('btn-csvdl');
      uploadBtnContainer.classList.remove('btn-update');
      uploadBtnContainer.classList.add('disabled');
    }
    
    // バリデーションメッセージをクリア
    validationMessage.value = '';
  });
});